<div class="loaderContainer">
  <motif-progress-loader
    [show]="isLoading()"
    [fullScreen]="true"
  ></motif-progress-loader>
</div>
